import { BackButton, Button } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const HeaderResponsive = ({ onShowMobileMenu, onBack, title, isMenuOpen, isTitleMainHeading = false, menuButtonRef, menuControlsId }) => {
  const { t } = useTranslation();
  const TitleTag = isTitleMainHeading ? 'h1' : 'div';

  return (
    <div className="header-responsive">
      {onBack && <BackButton color="inverse" onClick={onBack} />}
      <TitleTag className="header-responsive__mobile-menu-header-title">{title}</TitleTag>
      <Button
        ariaControls={menuControlsId}
        ariaExpanded={isMenuOpen}
        ariaLabel={isMenuOpen ? t('buttons:Close menu') : t('buttons:Open menu')}
        className="header-responsive__mobile-menu-header-button"
        iconSize="xl"
        isIconOnly
        leftIcon="menu"
        onClick={onShowMobileMenu}
        ref={menuButtonRef}
        variant="inverse-ghost"
      />
    </div>
  );
};

HeaderResponsive.propTypes = {
  isMenuOpen: PropTypes.bool,
  /** Pinta el título como <h1> en lugar de <div>, para pantallas cuyo encabezado principal en móvil es este. */
  isTitleMainHeading: PropTypes.bool,
  menuButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  menuControlsId: PropTypes.string,
  onBack: PropTypes.func,
  onShowMobileMenu: PropTypes.func,
  title: PropTypes.string,
};

export default HeaderResponsive;
